import React from 'react';
import { Trash } from 'lucide-react';

interface DeleteButtonProps {
  onClick: () => void;
}

const DeleteButton: React.FC<DeleteButtonProps> = ({ onClick }) => {
  return (
    <div className="relative group">
      <button
        className="text-red-600 hover:text-red-800"
        onClick={onClick}
        title="Delete"
      >
        <Trash className="w-4 h-4" />
      </button>
      <span className="absolute -top-7 left-1/2 -translate-x-1/2 px-2 py-1 text-xs text-white bg-black rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Delete
      </span>
    </div>
  );
};

export default DeleteButton;
